/* =============================================================
   Spacely — product-add-to-cart.js  (CORRECTED — v8)

   Verified 6 Jun 2026 in a live browser against the DRAFT theme.

   v8 fix: multi-word / punctuated options (e.g. "Sand Wash /
   Distressed") were failing — Webflow's <select> value is a slug
   ("sand-wash-distressed") that never matched the Shopify option
   text. Now matched on the option's real text with slug-safe
   normalization, so every product resolves regardless of option
   wording. Single-word products (Black / XS) were unaffected and
   still work — which is why it looked intermittent.

   TRUE ROOT CAUSE (proven in-browser):
   The add-to-cart JS and the Shopify backend both work — a real
   button click resolves the variant, adds it, and opens the cart
   drawer. The thing breaking checkout is the OMNISEND "JOIN GROUND
   CREW" popup: it auto-opens as a full-screen modal over the buy
   box on product pages. While it's up, every tap on "Add To Cart"
   lands on the popup, not the button. It auto-dismisses after a few
   seconds, which is why it feels intermittently broken. By the
   numbers it's 36 views / 0 interactions — blocking sales without
   capturing anyone.

   v7 = v5/v6 variant logic (correct for the Webflow/Udesly form)
   PLUS: on product pages only, suppress the Omnisend popup so the
   buy box is always reachable. This asset loads only on product
   pages, so the popup still runs everywhere else (home, collections,
   Field Notes). Conversion-first on the page where people buy.

   DURABLE FIX (do this in Omnisend, then this suppressor is belt-
   and-braces): set the Ground Crew Capture form to NOT display on
   /products/* (or switch its trigger to exit-intent / after-delay
   and cap frequency) so it never covers the buy box.
   ============================================================= */
(function () {

  /* ---------- SUPPRESS OMNISEND POPUP ON PRODUCT PAGES ---------- */
  function suppressOmnisendPopup() {
    if (!/\/products\//.test(window.location.pathname)) return;
    function hide() {
      var w = document.getElementById("omnisend-forms-wrapper");
      if (w && w.style.display !== "none") {
        w.style.display = "none";
        w.style.pointerEvents = "none";
      }
    }
    hide();
    try {
      var mo = new MutationObserver(hide);
      mo.observe(document.documentElement, {
        childList: true, subtree: true,
        attributes: true, attributeFilter: ["style", "class"]
      });
    } catch (e) { /* no-op */ }
    setInterval(hide, 800); // safety net for async re-render
  }

  /* ---------- ADD TO CART ---------- */
  function init() {
    suppressOmnisendPopup();

    var forms = document.querySelectorAll(
      'form[action="/cart/add"], form[data-node-type="commerce-add-to-cart-form"]'
    );

    Array.prototype.forEach.call(forms, function (form) {
      // --- Load this product's variants once (native, always present) ---
      var handle = (window.location.pathname.split("/products/")[1] || "")
        .split("?")[0].split("/")[0];
      var variantsPromise = handle
        ? fetch("/products/" + handle + ".js")
            .then(function (r) { return r.json(); })
            .then(function (p) { return (p && p.variants) || []; })
            .catch(function () { return []; })
        : Promise.resolve([]);

      var btn = form.querySelector(
        'input[type="submit"], button[type="submit"], ' +
        '.w-commerce-commerceaddtocartbutton, [data-node-type="add-to-cart-button"]'
      );
      var idInput = form.querySelector('input[name="id"]');
      var errEl = form.querySelector(
        '[data-node-type="commerce-add-to-cart-error"], .w-commerce-commerceaddtocarterror'
      );
      var defaultLabel = (btn && (btn.value || btn.textContent) || "Add to Cart").trim();
      if (/sold\s*out/i.test(defaultLabel)) defaultLabel = "Add to Cart";

      // Normalize an option label for matching. Webflow renders <select>
      // values as slugs ("sand-wash-distressed") while the Shopify variant
      // option is real text ("Sand Wash / Distressed"). Lowercasing alone
      // doesn't reconcile those, so we strip every non-alphanumeric char:
      // both collapse to "sandwashdistressed" and match reliably.
      function norm(x) {
        return String(x == null ? "" : x).toLowerCase().replace(/[^a-z0-9]+/g, "");
      }

      // --- Read the currently selected option values, in option order ---
      function getSelected() {
        var selects = form.querySelectorAll(
          'select[data-node-type="add-to-cart-option-select"]'
        );
        if (!selects.length) selects = form.querySelectorAll("select.w-commerce-commerceaddtocartoptionselect, select");
        if (selects.length) {
          return Array.prototype.map.call(selects, function (s) {
            // Prefer the visible option TEXT (matches the variant exactly);
            // fall back to the slugified value. Both get normalized.
            var opt = (s.options && s.selectedIndex >= 0) ? s.options[s.selectedIndex] : null;
            return norm(opt && opt.text ? opt.text : s.value);
          });
        }
        // Fallback: read the highlighted Webflow pills
        var groups = form.querySelectorAll('[data-node-type="add-to-cart-option-pill-group"]');
        return Array.prototype.map.call(groups, function (g) {
          var sel = g.querySelector(
            '.w--ecommerce-pill-selected, [data-option-selected="true"], .w--current, [aria-checked="true"]'
          );
          return sel ? norm(sel.getAttribute("data-option-name") || sel.textContent) : "";
        });
      }

      // --- Resolve the selected values to a concrete variant ---
      function variantOpts(v) {
        return [v.option1, v.option2, v.option3]
          .filter(function (o) { return o !== null && o !== undefined; })
          .map(function (o) { return norm(o); });
      }
      function findVariant(variants, sel) {
        var v = variants.find(function (v) {
          var opts = variantOpts(v);
          return opts.length === sel.length &&
                 opts.every(function (o, i) { return o === sel[i]; });
        });
        if (v) return v;
        var nonEmpty = sel.filter(Boolean);
        if (nonEmpty.length) {
          v = variants.find(function (v) {
            var opts = variantOpts(v);
            return nonEmpty.every(function (s) { return opts.indexOf(s) > -1; });
          });
        }
        return v;
      }

      function setButton(label, disabled) {
        if (!btn) return;
        if (btn.tagName === "INPUT") { btn.value = label; }
        else { btn.textContent = label; }
        btn.disabled = !!disabled;
        if (disabled) { btn.setAttribute("aria-disabled", "true"); }
        else { btn.removeAttribute("aria-disabled"); }
      }

      function clearError() { if (errEl) { errEl.style.display = "none"; } }
      function showError(msg) {
        if (errEl) { errEl.textContent = msg; errEl.style.display = "block"; }
        else { alert(msg); }
      }

      function sync() {
        variantsPromise.then(function (variants) {
          if (!variants.length) return;
          var v = findVariant(variants, getSelected());
          if (!v) { setButton(defaultLabel, false); return; }
          if (idInput) idInput.value = v.id;
          setButton(v.available === false ? "Sold Out" : defaultLabel, v.available === false);
        });
      }

      form.addEventListener("change", function () { clearError(); sync(); });
      Array.prototype.forEach.call(
        form.querySelectorAll('[data-node-type="add-to-cart-option-pill"]'),
        function (pill) {
          pill.addEventListener("click", function () { clearError(); setTimeout(sync, 60); });
        }
      );
      sync(); // initial state

      // --- Submit ---
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        clearError();
        setButton("Adding…", true);

        variantsPromise.then(function (variants) {
          var v = findVariant(variants, getSelected());
          if (!v) throw new Error("variant-not-found");
          if (v.available === false) throw new Error("sold-out");
          return fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
          });
        })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (d) { throw new Error(d.description || "add-failed"); });
          }
          return fetch("/cart.js");
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent("cart:change", { detail: cart }));
          document.dispatchEvent(new CustomEvent("cart:refresh", { detail: cart }));
          if (typeof window.updateCart === "function") window.updateCart();
          if (typeof window.openCartDrawer === "function") {
            window.openCartDrawer();
          } else {
            window.location.href = "/cart";
          }
        })
        .catch(function (err) {
          console.error("ATC error:", err);
          showError(
            err.message === "sold-out"
              ? "Sold out in that size — try another."
              : "Couldn't add to cart — please try again."
          );
        })
        .finally(function () { sync(); });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
